
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4340"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4340"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $1Knfl = parcelRequire("1Knfl");

var $kB2C5 = parcelRequire("kB2C5");

var $lNb7j = parcelRequire("lNb7j");
var $29Z9A = parcelRequire("29Z9A");

var $aqOVV = parcelRequire("aqOVV");
var $kMjUy = parcelRequire("kMjUy");
var $cobnL = parcelRequire("cobnL");
var $cNXNW = parcelRequire("cNXNW");
var $lHFYh = parcelRequire("lHFYh");
//
//
// import the geojson files -- there are more elegant ways to do this, but this is straightforward method for this technology stack
var $30c3ca9318835495$exports = {};
$30c3ca9318835495$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[141.3407656096963,-9.4639093163712],[147.3369574274683,45.04646713435508],[113.42130767414551,41.27686333706416],[97.39041307860668,18.182180021210485],[90.12731621198441,12.248830273496864],[93.81240575762206,2.584572790926643],[101.89403037176828,-8.565418715654474],[117.39791077749709,-11.610300875953897],[132.76990521383368,-9.516113273415456],[141.3407656096963,-9.4639093163712]]],"type":"Polygon"}}]}');


var $276efc21237739dd$exports = {};
$276efc21237739dd$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[114.24049472637273,22.54834845949567],[114.16572017600089,22.559438766434795],[114.03618778477767,22.506475755520114],[113.81849321677117,22.369453015394114],[113.75705793991006,22.129648079446667],[113.86790854815916,22.06901397824862],[114.32333092662424,22.092528252790714],[114.4301748863839,22.48796708119191],[114.33267808825076,22.553351050937266],[114.24049472637273,22.54834845949567]]],"type":"Polygon"}}]}');


var $86f369b64a76e93b$exports = {};
$86f369b64a76e93b$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[93.07521086152968,4.847497315841466],[101.4558292349306,-5.730313839356356],[116.96350779666284,-11.827051705492465],[124.22357412444956,-11.303689113667517],[141.02846150353025,-9.32489629821832],[141.15667324689758,-2.6645105530845115],[128.32122954732893,3.6174349076974437],[117.87077336405389,4.1385506626944135],[115.70627987137948,4.338725090800352],[114.35803531655938,1.2243781542084093],[110.71275592201766,1.0297407377764785],[109.68850444189837,2.115687935597265],[105.15422354882037,0.24686254762553972],[102.61068852537028,1.1510942561412065],[98.29437944501518,4.652534735765258],[95.28970982959675,6.40602665332959],[93.07521086152968,4.847497315841466]]],"type":"Polygon"}}]}');


var $1e8d3bb92608ae27$exports = {};
$1e8d3bb92608ae27$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[102.21746372078178,6.398391432926061],[101.76904431366881,5.811376670366343],[100.98915184213337,5.724719467097856],[101.14254541949833,6.208279394674321],[100.24977241668779,6.710506438799385],[99.97380968500732,6.346636961662071],[99.93275302937576,5.0160165589699375],[100.68668827507832,3.0545988187074755],[102.01646592842678,1.95608798126689],[103.18753561568246,1.491328633235483],[104.37602118254483,1.731494427185993],[104.4280609924831,3.6949966123298026],[103.6032550858585,6.398374367320727],[102.21746372078178,6.398391432926061]]],"type":"Polygon"}}]}');


var $51679af99f6aee0d$exports = {};
$51679af99f6aee0d$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[98.57430848533579,9.91087601931362],[98.02022701199644,9.28150888792662],[97.98559276672313,7.64179623841251],[99.8843854760321,6.1207382815304925],[101.10510980079073,6.213605894366793],[101.84053465116568,5.709572981950146],[102.50861483351889,6.207233652743028],[102.90206127265412,11.766422466794879],[102.35014240570888,13.66240399214486],[103.66573060557397,14.484299648951762],[105.45628926310752,14.474428820099305],[104.74478532712567,17.4764643587705],[103.43991911786327,18.49160442240428],[101.02770268218751,17.579444501917237],[100.08308895956691,20.533009409505496],[97.94574320536532,19.80646985375627],[97.34485179994584,18.561856163866253],[98.87013220957601,16.37382593913243],[98.56093951674904,15.318682855450973],[98.23367284432885,14.95917292987508],[99.12107052761064,13.806454077560858],[99.13658136622666,12.81330157243083],[99.66898094632887,11.810761279986764],[98.8810415739772,10.766776688835535],[98.57430848533579,9.91087601931362]]],"type":"Polygon"}}]}');


var $03d75808c53f36bf$exports = {};
$03d75808c53f36bf$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-79.21167029384021,26.92562342198319],[-78.5728415233917,24.47719664083276],[-77.52840718440474,23.42076274382076],[-74.009778877331,21.92377096306491],[-72.44819743845727,22.25262738259333],[-74.20244152238718,24.26475547530424],[-76.98083966687739,27.25062496315094],[-79.21167029384021,26.92562342198319]]],"type":"Polygon"}}]}');


var $a3a6f346ba521bef$exports = {};
$a3a6f346ba521bef$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-125.61193198541402,48.14467991755245],[-94.26945666433262,48.999994018638745],[-83.89378215804861,46.241338843409835],[-82.76303386346753,42.20748456210973],[-70.55044609830487,45.276043467285746],[-68.03256280407591,47.575780163027645],[-66.25726332310855,43.194793629485815],[-44.00385786844629,46.950676227443665],[-31.309900030518577,66.09890502009515],[-16.73746874409096,69.96311014838372],[-0.6134416037064057,84.18683226319638],[-155.40243228553985,77.55301251709358],[-140.58287050235185,69.59557526401713],[-141.13767758353413,53.95444434494394],[-125.61193198541402,48.14467991755245]]],"type":"Polygon"}}]}');


var $31321a14c333cbab$exports = {};
$31321a14c333cbab$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-130.68985336954378,54.7170016887593],[-133.7270038704749,54.10563345983482],[-131.55894185429892,50.06378732252435],[-124.6111631728173,48.44822270699515],[-122.94663216224788,48.166103638823216],[-122.90887283738311,48.782728461373864],[-122.66533421544057,48.98465898275495],[-119.17659626380262,48.99504702770696],[-114.1969661784866,49.068326186672806],[-119.6499067340923,53.53331723021856],[-119.92408689442937,59.973610084010375],[-138.9753325118095,60.027231622044326],[-137.6078062648365,59.02415687332319],[-135.37945850834245,59.79683856995652],[-133.570392777889,58.625503630411146],[-131.82325770707143,56.64902704912831],[-130.0023954568602,56.04269148442978],[-129.8990977129143,55.23115932298822],[-130.68985336954378,54.7170016887593]]],"type":"Polygon"}}]}');


var $a5f0f149325e723f$exports = {};
$a5f0f149325e723f$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-66.89169962029709,44.77823199043826],[-67.06295434788478,44.51933379846167],[-65.46815387526351,43.22311724881456],[-59.401522164004916,45.52213664590528],[-59.80042579652985,47.18754923560499],[-61.08455314791894,47.11846102143562],[-61.95636288317931,46.09592537849821],[-63.25833113625511,45.96723735316317],[-63.92499039868629,46.039867188856874],[-66.89169962029709,44.77823199043826]]],"type":"Polygon"}}]}');


var $d5a09da1de6dc512$exports = {};
$d5a09da1de6dc512$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-117.29405111513921,32.50542380460658],[-117.24791016063199,26.542474114856716],[-100.93869156210184,14.953492608539705],[-79.25548839658953,6.494004270715763],[-95.37095147899674,1.3625640683994362],[-80.106898081393,-24.330147364741364],[-77.29331221814203,-62.08905858284448],[-25.162307577628354,-56.71387815902105],[-29.8418425576985,-2.9561142012951933],[-58.781026299249746,11.107036644284236],[-69.9970011668357,14.186363330548488],[-77.63505683458095,11.509613475986683],[-82.86904355387725,17.527357045113106],[-86.75785182823932,22.7039901712662],[-96.86320363159808,25.81678181545101],[-117.29405111513921,32.50542380460658]]],"type":"Polygon"}}]}');


var $b5c34c24deab1938$exports = {};
$b5c34c24deab1938$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[48.838514502816366,-60.915159547251235],[-135.79391818533466,-60.915159547251235],[-135.79391818533466,-83.86237464071647],[48.838514502816366,-83.86237464071647],[48.838514502816366,-60.915159547251235]]],"type":"Polygon"}}]}');


var $2607aaa7b6e49ddd$exports = {};
$2607aaa7b6e49ddd$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-87.83921270250926,18.185727795187105],[-88.02394868515385,18.16977175759574],[-88.0351448053146,18.411614336334935],[-88.49417926778267,18.49386411844219],[-88.86637147497183,17.90081365640225],[-89.14342245055242,17.935419882283597],[-89.22173575881604,15.879216124640237],[-88.91120347727802,15.897888197049369],[-87.22062706365324,17.346089414244304],[-87.83921270250926,18.185727795187105]]],"type":"Polygon"}}]}');


var $681745804c53fcce$exports = {};
$681745804c53fcce$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-86.02670216117419,11.052557493086255],[-85.9994414356058,9.756173284620104],[-83.87229509427546,8.535624593914704],[-82.8450833995305,8.004872322836363],[-82.96327849940664,8.292822243674195],[-82.93664662453277,9.100980033207364],[-82.93612935422999,9.47816824968855],[-82.5087444590895,9.594869840826732],[-83.67230942082058,10.900852261189911],[-84.83586732265096,10.936537709173948],[-85.57217936012343,11.24875287080934],[-85.67210661871232,11.07025002738223],[-86.02670216117419,11.052557493086255]]],"type":"Polygon"}}]}');


var $ba9dd0db7ca9ae2f$exports = {};
$ba9dd0db7ca9ae2f$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-80.23573540305628,-3.309425645815054],[-80.4432772202309,-4.22327861469725],[-79.1528748955958,-4.973674822778634],[-75.64213677269153,-1.584765943366321],[-78.94049022929966,1.5255002393408859],[-93.38599602867485,1.3588075228277887],[-92.59264744466863,-2.48606373904596],[-80.23573540305628,-3.309425645815054]]],"type":"Polygon"}}]}');


var $9026200a7b91ca81$exports = {};
$9026200a7b91ca81$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-92.45261462046399,0.21604359398997985],[-90.9814481178045,-1.9093172214256384],[-88.85095209563595,-1.431588072198366],[-88.33319786009811,-0.048503956190984354],[-90.5900493745428,1.2805979497391462],[-92.45261462046399,0.21604359398997985]]],"type":"Polygon"}}]}');


var $92e5dbe1e225a629$exports = {};
$92e5dbe1e225a629$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-117.20023288064766,32.51888012066348],[-115.39570052640838,26.465180532380487],[-105.14011783784193,18.127385372920088],[-92.37164576052291,13.960759196172603],[-91.76785136529452,15.98631706638838],[-90.43993445706752,16.360767895707596],[-91.22738005469935,17.56138591949201],[-89.21214773332167,17.89756643969919],[-88.2250140795741,18.578920626210362],[-87.8424350124321,18.124745998402503],[-86.04555275833397,21.37341071869035],[-97.01147571537908,25.91239900523246],[-101.60573790116567,29.869360329167932],[-103.75538090804312,29.262392182463714],[-106.43739417958147,31.649990582585048],[-110.93088716507529,31.31454083351379],[-114.68796940427566,32.73559062432459],[-117.20023288064766,32.51888012066348]]],"type":"Polygon"}}]}');


var $d7c6f02f7f27b4c9$exports = {};
$d7c6f02f7f27b4c9$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-77.84050465334256,7.196629099371918],[-77.13007542666841,7.933199229888814],[-77.3825217720186,8.67617834717737],[-78.37352213047464,9.816572461027576],[-82.53348406902234,9.571760054669014],[-82.88872341450116,9.62948221111543],[-83.05164482424911,8.328560417188314],[-82.88414795819546,8.016642476274114],[-82.08099217720113,6.7024944297843945],[-77.84050465334256,7.196629099371918]]],"type":"Polygon"}}]}');


var $6c3a5046ad779a63$exports = {};
$6c3a5046ad779a63$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-68.55556374761936,-27.056355204849858],[-71.76138670025271,-27.69711389009081],[-73.32149483064215,-34.70589062311604],[-76.68093953263356,-44.43630156785239],[-76.60566456343986,-53.675891316776884],[-68.11017835050363,-57.00281571495548],[-66.5027088858963,-55.29452606261076],[-71.99444474806523,-50.856223022171626],[-71.08489640521643,-45.914521273774724],[-68.55556374761936,-27.056355204849858]]],"type":"Polygon"}}]}');


var $15c75b7b51670948$exports = {};
$15c75b7b51670948$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[13.430859918667693,45.51233387142054],[13.474763858105831,45.00675458162431],[15.307442111377554,43.55153942995349],[16.730955562735915,42.6291823280211],[18.63986680037891,42.35214132998615],[15.068304367378403,45.476084182773434],[13.430859918667693,45.51233387142054]]],"type":"Polygon"}}]}');


var $49cea4a4e10fb765$exports = {};
$49cea4a4e10fb765$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-5.671066885204624,35.60087853504402],[-0.5477078221992713,35.25978785841211],[3.7548188267220723,36.548677487960646],[7.667842126196831,35.71908891916702],[10.120392463161352,36.18664141701788],[9.527082532000804,33.880533277501925],[12.551747100655604,31.789707115955352],[17.758498955941235,39.21484084598009],[9.114709100954457,44.89876599955625],[3.307834942093905,44.173035673150736],[-1.8169172905893447,39.899281062401144],[-2.0780193114940175,38.21061844438273],[-5.526203813438201,37.30441292819833],[-5.671066885204624,35.60087853504402]]],"type":"Polygon"}}]}');


var $a7ba2a985720a50e$exports = {};
$a7ba2a985720a50e$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[19.530164339471867,39.671299424952224],[20.32832986000986,37.652027000711115],[24.041302153971174,34.584335839754786],[27.153892950932516,34.84965155014592],[28.73070302983922,36.400679711496736],[26.245399794270412,36.85410265578243],[26.180244847028064,38.91623996071502],[25.583552641825662,39.85515639501557],[26.135782181371894,40.81048424021651],[25.976780886929276,41.31288026000652],[22.993707566834047,41.17563781520349],[21.47002035510269,40.60654314672769],[19.530164339471867,39.671299424952224]]],"type":"Polygon"}}]}');


var $663e0fdde46f9191$exports = {};
$663e0fdde46f9191$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[18.500143076273844,42.40903980470031],[18.83613536772188,42.05754635019065],[19.372505455741845,41.851226165477925],[19.403312175606573,42.10332215025679],[19.282995962414816,42.18113094250259],[19.341673177219008,42.22440929532945],[19.542885770169136,42.49136030442628],[18.534641714983906,42.938728875436425],[18.574529067064702,42.72445151743608],[18.442249076307178,42.55013740446773],[18.500143076273844,42.40903980470031]]],"type":"Polygon"}}]}');


var $092af8f0849decf3$exports = {};
$092af8f0849decf3$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[29.06748336445247,41.531871280872906],[28.404952244943246,40.91452138478053],[26.17026562914694,40.27387966303297],[25.337855281662485,39.002082442862076],[25.86775027961812,37.02934903117939],[28.978474316496033,35.66958882404596],[34.94122210542801,35.991279512484525],[41.548056888590736,41.56540045069258],[34.49206214943541,42.65329946888116],[29.06748336445247,41.531871280872906]]],"type":"Polygon"}}]}');


var $a7225a92cf29dae1$exports = {};
$a7225a92cf29dae1$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[89.20710820839486,21.368412345943725],[67.9526480834466,23.919732819341448],[73.1683711294248,10.890774411999331],[46.13125420798232,0.5780552517122288],[45.43452433006246,-10.995868136428285],[83.6309603332075,4.870673639773358],[89.20710820839486,21.368412345943725]]],"type":"Polygon"}}]}');


var $fb317bb72350f342$exports = {};
$fb317bb72350f342$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[68.13692186188689,23.817894635358073],[68.88635701427268,21.73000667060633],[70.94487196624414,19.854920337075967],[77.155692018379,7.42339506411227],[78.9344686632474,8.165826768007975],[80.93061931080894,12.424338940273529],[81.25973479782789,15.124636408176173],[89.1623280061799,21.43864067048517],[88.71609356229328,24.141199992630277],[87.54454708705015,26.314479919028855],[80.12978830112343,28.85006173634413],[80.84807176603852,30.27720998654975],[76.58432340636705,33.063357234649715],[74.64813658231736,31.930206498848023],[73.0108585110282,28.912956094960208],[70.53780995418094,28.123054150236783],[69.62389563044505,26.952474773059677],[71.10262234599463,24.483720012686575],[68.13692186188689,23.817894635358073]]],"type":"Polygon"}}]}');


var $d376275bafa85362$exports = {};
$d376275bafa85362$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[71.91757491431792,8.745953895071949],[71.59994462778383,-1.6836380552966688],[75.66077682810521,-2.1329839848940253],[75.26465526150886,3.802330164639372],[73.86820606112508,8.373756858483844],[71.91757491431792,8.745953895071949]]],"type":"Polygon"}}]}');


var $bb30d3fec2bd183e$exports = {};
$bb30d3fec2bd183e$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[43.215157073136766,-0.9370118743412092],[43.215157073136766,-10.925871016596247],[58.65445686563936,-10.925871016596247],[58.65445686563936,-0.9370118743412092],[43.215157073136766,-0.9370118743412092]]],"type":"Polygon"}}]}');


var $627aa8e239657c5b$exports = {};
$627aa8e239657c5b$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[54.13928458575509,24.57472893194931],[54.13928458575509,24.207542954882683],[54.75034039843399,24.207542954882683],[54.75034039843399,24.57472893194931],[54.13928458575509,24.57472893194931]]],"type":"Polygon"}}]}');


var $32c2418b10303e70$exports = {};
$32c2418b10303e70$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[56.22443380221583,26.51840826445752],[51.56976184286282,24.421171623322124],[51.552983663028215,24.023345646972615],[52.54289627333449,22.892093366769487],[55.118346878116796,22.64456118657033],[55.823030431216836,24.901476669607348],[56.368321275877406,24.977545024254056],[56.37671036579653,25.62221726919904],[56.15859402793228,25.637344607230247],[56.09987039850759,26.060129008865772],[56.22443380221583,26.51840826445752]]],"type":"Polygon"}}]}');


var $3c952baa25472a96$exports = {};
$3c952baa25472a96$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[31.943024661700804,29.978185767025565],[36.771078037090035,18.484700136479177],[38.876823648616636,14.488333700162073],[43.389491616743584,9.30467287380013],[55.84553202007797,15.544481672879328],[62.50821665777684,23.157827481155977],[56.11631078068086,26.52333135309283],[47.565329476666136,32.55086900551878],[31.943024661700804,29.978185767025565]]],"type":"Polygon"}}]}');


var $2f9f8b130b23fc24$exports = {};
$2f9f8b130b23fc24$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[32.45880437429949,30.08832516473653],[32.073135564127256,29.435141244989012],[35.013427184260195,23.510561564081243],[36.8526276594103,21.310385499620665],[37.112475521194824,18.88945999349764],[37.69132218287419,18.148445269309278],[39.6644317523548,14.903328285661587],[42.86427500718577,12.528106232376771],[43.747624219869465,12.751004479414604],[42.81951158117843,17.40663943116263],[39.63825149648852,22.190976207169925],[37.956082798412154,25.3512224796453],[34.950531768300465,29.553329793709224],[32.45880437429949,30.08832516473653]]],"type":"Polygon"}}]}');


var $af12d6d8a6101dc2$exports = {};
$af12d6d8a6101dc2$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-28.472391045486518,65.44987685032723],[-10.775781348430911,50.54302236423021],[-3.4509110754219137,49.35373359243221],[1.87841135532517,50.996031288065524],[8.7788687299022,57.94471437251636],[14.261392233367758,54.834881844831926],[20.202179570207903,57.82081183445021],[19.851316110429792,61.58892304729147],[20.255444348898948,63.1066361345307],[24.099772881942926,65.49509661391758],[22.583112804656793,71.32669015968094],[-5.634464819220142,70.70430303266284],[-28.472391045486518,65.44987685032723]]],"type":"Polygon"}}]}');


var $3fce1b16f8360a96$exports = {};
$3fce1b16f8360a96$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-24.285985714113423,66.81818862222948],[-26.308759766727377,65.12416398172076],[-20.061083786532834,62.390620143473285],[-10.998477321192041,63.69963664833318],[-11.602620833875022,67.1731299797535],[-24.285985714113423,66.81818862222948]]],"type":"Polygon"}}]}');


var $0129b6389fb33af9$exports = {};
$0129b6389fb33af9$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[30.933519409629554,69.75793141092834],[31.84268606436052,70.99333126565975],[20.49484984837349,71.7694811929882],[2.4883804452623792,63.1536022385867],[4.52534424180638,59.06351010379646],[6.8652479589475774,57.43956684363684],[10.84913107651073,58.92598243491727],[11.59790884237674,58.898480411891256],[12.42923225696552,60.08262900252703],[11.965770325904913,63.20792248208613],[12.756373598520184,64.01795633842067],[14.193109376326305,64.1302341525739],[14.48325283532185,65.39323080242673],[17.088786108526023,68.12770127536479],[23.76720954385496,68.74493046601023],[25.746286488091584,68.90038079185248],[26.749650738611336,69.9465219021796],[30.933519409629554,69.75793141092834]]],"type":"Polygon"}}]}');


var $1708288b2429e033$exports = {};
$1708288b2429e033$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[24.185099489209847,65.64670301817839],[20.997377833646624,69.0390906444714],[12.017606347429961,63.25299753588982],[12.766059194806388,61.093208719226254],[11.65436051021544,58.930780643055016],[11.02748371031987,58.945303303169624],[11.774743616966646,56.462233646332834],[12.565547428638894,56.10972783674052],[12.921565552747865,55.575088888825945],[12.7144929939993,54.91556962819263],[15.796273888561359,54.758637369430176],[19.60034774052687,57.49688375443074],[19.40603216580712,60.65576147261095],[19.778850865044006,62.691186006525754],[24.185099489209847,65.64670301817839]]],"type":"Polygon"}}]}');


var $48a308fe5e201e99$exports = {};
$48a308fe5e201e99$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-10.720370431868133,53.838069715043844],[-11.168767073182721,51.341480837224026],[-4.715716223302849,49.38150194404483],[0.11249326152005779,50.41825592322857],[2.0953620759473495,51.273605549809815],[2.4079525662990307,53.04387610390401],[0.49127156337021916,57.148320963909015],[-0.40592513161706734,61.58721035519102],[-9.922208999421741,57.69689299237234],[-10.720370431868133,53.838069715043844]]],"type":"Polygon"}}]}');


var $1d668e74378cf307$exports = {};
$1d668e74378cf307$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[183.40228929742318,-15.129863598691813],[155.67756359915154,-0.19672630311190176],[140.81306797992897,-0.5621208264181234],[141.1724315265957,-10.372388011412212],[131.92713007850278,-10.066754561153019],[125.48873840786291,-12.235911629402807],[109.80420361922654,-17.42984557174435],[109.05456809037463,-34.29001301534662],[133.403803855844,-40.93093107251049],[169.82119951472322,-53.42331086058456],[186.16359573840452,-40.370025834000096],[183.40228929742318,-15.129863598691813]]],"type":"Polygon"}}]}');


var $d371eefd5c97e65d$exports = {};
$d371eefd5c97e65d$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[154.30942335205015,-34.78729694071991],[155.16069324812622,-24.670573918216917],[143.26989373187757,-9.969953015146217],[127.49528803329429,-9.838326062416542],[110.4593650286659,-22.946590516508977],[112.8679993785156,-36.54186948106209],[148.8209354696881,-45.83169560173039],[154.30942335205015,-34.78729694071991]]],"type":"Polygon"}}]}');


var $0c6c2508da553d7a$exports = {};
$0c6c2508da553d7a$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-181.6879257778749,-15.363164865839337],[-184.19761725061102,-17.99254637940085],[-180.8463076877611,-21.003815974830715],[-176.61472057113247,-18.588459717609013],[-179.17084363399144,-15.08817942020535],[-181.6879257778749,-15.363164865839337]]],"type":"Polygon"}}]}');


var $6d1706364dd4c128$exports = {};
$6d1706364dd4c128$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[164.58641832665893,-17.87657133931374],[162.89094513163138,-19.324005177435097],[164.7502836782262,-22.01537230834984],[167.7079664649376,-23.57403332109554],[169.0862692511539,-21.63072586573624],[164.58641832665893,-17.87657133931374]]],"type":"Polygon"}}]}');


var $14c3c45cca4a3d87$exports = {};
$14c3c45cca4a3d87$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[172.9259179845477,-33.98979270724431],[166.45522140999879,-39.983220373016394],[162.69468233217276,-49.847358442405074],[168.90601878323594,-53.37899143089624],[184.61019257578482,-44.53949595560419],[180.25281432936225,-37.169078415394836],[172.9259179845477,-33.98979270724431]]],"type":"Polygon"}}]}');


var $af44d5a09feb2d76$exports = {};
$af44d5a09feb2d76$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[155.71873370559177,-4.803097574312886],[150.92182335165978,0.15161825679955143],[141.03657795541875,-1.666965397517302],[141.00755136034172,-9.495748020047756],[154.40684368480186,-12.216057471149284],[155.9089071173404,-8.170273191899454],[156.34597867219713,-6.337548674306518],[155.71873370559177,-4.803097574312886]]],"type":"Polygon"}}]}');


var $c7841b9de5d3782b$exports = {};
$c7841b9de5d3782b$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-141.6012046780749,72.82753064248371],[-164.44204860787883,71.57211897695106],[-168.06381894636948,68.2954020323852],[-170.3918828935104,61.47572865398763],[-194.10748524471452,52.888037719192795],[-117.0953624431742,32.49928306087908],[-97.15560863287115,25.775959001217743],[-79.54525199436156,23.497197385187974],[-79.52862053839948,28.666171269704776],[-66.39722597369624,41.63881948079515],[-67.57457111962233,47.55875203982376],[-86.24829033927024,49.40926759916505],[-125.47624604638764,47.81708252037237],[-140.5385145474753,59.5085064264849],[-141.6012046780749,72.82753064248371]]],"type":"Polygon"}}]}');


var $f43fd234283a2360$exports = {};
$f43fd234283a2360$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-172.3597602302871,51.0869877326102],[-144.18561768439363,57.495944524534224],[-125.11291877023285,49.17851676478193],[-129.24544931312656,55.584482071445905],[-135.44628698415747,59.911539695274655],[-141.3030983076216,60.434141863667435],[-140.80623312325997,72.14938422907159],[-169.47655122832734,70.95946625306539],[-167.6563447005465,64.29210409579375],[-172.3597602302871,51.0869877326102]]],"type":"Polygon"}}]}');


var $599eaf71ec24f702$exports = {};
$599eaf71ec24f702$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-81.40700089685271,30.700537086701274],[-84.62837811801556,30.78143989025179],[-87.46582096482277,30.651823254145967],[-87.56219405787051,30.204049030530157],[-83.97475845335121,29.275247249470468],[-83.35284699959432,28.245701677268002],[-81.87306737151782,24.793238979587045],[-79.86735022303866,24.99008353274361],[-79.7954503737093,27.27182009477191],[-81.40700089685271,30.700537086701274]]],"type":"Polygon"}}]}');


var $c1bc278aff1d86dd$exports = {};
$c1bc278aff1d86dd$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-66.86004522144735,44.7969300167328],[-69.7073027193188,44.85550588203603],[-70.81012826084398,43.704712103307344],[-71.78649522526659,42.08661059177547],[-71.8398235879473,41.31475333190724],[-69.91279736522714,41.12537317549297],[-66.86004522144735,44.7969300167328]]],"type":"Polygon"}}]}');


var $079d79256b03a7b3$exports = {};
$079d79256b03a7b3$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[7.650390008200759,43.762008965400696],[6.659837966185819,45.349056395274374],[2.694833829160615,43.29162445920804],[2.5052586537567834,42.380705009915886],[3.4105762117771974,42.44430360026675],[6.499814537007381,42.592199273150186],[7.650390008200759,43.762008965400696]]],"type":"Polygon"}}]}');


var $11130b7751811b21$exports = {};
$11130b7751811b21$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[7.453179299001505,43.85147491898957],[9.899641635233849,43.206113227074525],[12.867971755440209,39.05924289793023],[11.956768840807257,37.13104992996563],[16.241603529484905,30.692379874938723],[38.961270455447874,30.097090463512927],[37.49541398304319,37.43714395578557],[29.20231501547437,41.556661373478505],[13.277466910157415,46.29675404634409],[9.120653546339014,45.206431310897756],[7.453179299001505,43.85147491898957]]],"type":"Polygon"}}]}');


var $ab64cf15b34dd589$exports = {};
$ab64cf15b34dd589$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[13.954438898348343,45.739763237702135],[13.622196521016377,46.198826681090026],[13.694881695646188,46.50776946756332],[12.346418794422647,46.773354406438585],[12.154275366892989,47.084796270257726],[8.979293761835834,46.61917511215549],[6.783350848031432,46.00771021155586],[6.621227983991986,45.081950339179315],[7.667409812162106,44.092675799108065],[7.56355957122949,43.830651441108216],[7.443073493399197,38.88766806564925],[14.969832602976396,36.18354074264671],[19.200980496296808,39.747219907622025],[13.097078072655677,44.96653886906029],[13.954438898348343,45.739763237702135]]],"type":"Polygon"}}]}');


var $121626504812ba2e$exports = {};
$121626504812ba2e$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[14.500179965987513,35.98148826933698],[14.346221507791142,36.132864093962226],[14.075757911275389,36.132863701657726],[14.246361123073854,35.90063905959629],[14.504341005397976,35.7386820234651],[14.67494362123793,35.86355035363229],[14.500179965987513,35.98148826933698]]],"type":"Polygon"}}]}');


var $31df448cad09f0cc$exports = {};
$31df448cad09f0cc$exports = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"coordinates":[[[-7.401388556740386,37.26571132283944],[-5.499125051883169,36.0006762166944],[-1.458957038273553,36.71666855445794],[5.089590269558386,40.14894930137103],[3.195637628659938,42.507109356667655],[-2.8163798887649705,40.57181728447864],[-5.685624901003649,38.95533721012288],[-7.401388556740386,37.26571132283944]]],"type":"Polygon"}}]}');


//
// for these examples it is ok to assume we have a single polygon.
// in the shape of [ [ [long, lat], [long, lat], ... ] ]
// which needs to be mapped to
// [ lat, long, lat, long, ... ]
const $409b4025aeb4477c$var$toLatLongStr = (geoJSON)=>{
    const coordinates = [];
    for (const coord of geoJSON.features[0].geometry.coordinates[0])coordinates.push(coord[1], coord[0]);
    return JSON.stringify(coordinates);
};
//
// create an array of label / value pairs
const $409b4025aeb4477c$var$customGeoPolygonsGrouped = ()=>{
    return [
        [
            {
                label: "Asia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($30c3ca9318835495$exports))))
            },
            {
                label: "Hong Kong",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($276efc21237739dd$exports))))
            },
            {
                label: "Indonesia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($86f369b64a76e93b$exports))))
            },
            {
                label: "Malaysia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($1e8d3bb92608ae27$exports))))
            },
            {
                label: "Thailand",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($51679af99f6aee0d$exports))))
            }
        ],
        [
            //
            {
                label: "Bahamas",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($03d75808c53f36bf$exports))))
            }
        ],
        [
            //
            {
                label: "Canada",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($a3a6f346ba521bef$exports))))
            },
            {
                label: "British Columbia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($31321a14c333cbab$exports))))
            },
            {
                label: "Nova Scotia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($a5f0f149325e723f$exports))))
            }
        ],
        [
            //
            {
                label: "Central/South America",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($d5a09da1de6dc512$exports))))
            },
            {
                label: "Antartica",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($b5c34c24deab1938$exports))))
            },
            {
                label: "Belize",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($2607aaa7b6e49ddd$exports))))
            },
            {
                label: "Costa Rica",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($681745804c53fcce$exports))))
            },
            {
                label: "Ecuador",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($ba9dd0db7ca9ae2f$exports))))
            },
            {
                label: "Galapagos",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($9026200a7b91ca81$exports))))
            },
            {
                label: "Mexico",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($92e5dbe1e225a629$exports))))
            },
            {
                label: "Panama",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($d7c6f02f7f27b4c9$exports))))
            },
            {
                label: "Patagonia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($6c3a5046ad779a63$exports))))
            }
        ],
        [
            //
            {
                label: "East Mediterranean",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($49cea4a4e10fb765$exports))))
            },
            {
                label: "Croatia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($15c75b7b51670948$exports))))
            },
            {
                label: "Greece",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($a7ba2a985720a50e$exports))))
            },
            {
                label: "Montenegro",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($663e0fdde46f9191$exports))))
            },
            {
                label: "Turkey",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($092af8f0849decf3$exports))))
            }
        ],
        [
            //
            {
                label: "Indian Ocean",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($a7225a92cf29dae1$exports))))
            },
            {
                label: "India",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($fb317bb72350f342$exports))))
            },
            {
                label: "Maldives",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($d376275bafa85362$exports))))
            },
            {
                label: "Seychelles",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($bb30d3fec2bd183e$exports))))
            }
        ],
        [
            //
            {
                label: "Middle East",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($3c952baa25472a96$exports))))
            },
            {
                label: "Abu Dhabi",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($627aa8e239657c5b$exports))))
            },
            {
                label: "Dubai",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($32c2418b10303e70$exports))))
            },
            {
                label: "Red Sea",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($2f9f8b130b23fc24$exports))))
            }
        ],
        [
            //
            {
                label: "Northern Europe",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($af12d6d8a6101dc2$exports))))
            },
            {
                label: "Iceland",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($3fce1b16f8360a96$exports))))
            },
            {
                label: "Norway",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($0129b6389fb33af9$exports))))
            },
            {
                label: "Sweden",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($1708288b2429e033$exports))))
            },
            {
                label: "UK and N. Ireland",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($48a308fe5e201e99$exports))))
            }
        ],
        [
            //
            {
                label: "Oceania",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($1d668e74378cf307$exports))))
            },
            {
                label: "Australia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($d371eefd5c97e65d$exports))))
            },
            {
                label: "Fiji",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($0c6c2508da553d7a$exports))))
            },
            {
                label: "New Caledonia",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($6d1706364dd4c128$exports))))
            },
            {
                label: "New Zealand",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($14c3c45cca4a3d87$exports))))
            },
            {
                label: "Papua New Guinea",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($af44d5a09feb2d76$exports))))
            }
        ],
        [
            //
            {
                label: "United States",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($c7841b9de5d3782b$exports))))
            },
            {
                label: "Alaska",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($f43fd234283a2360$exports))))
            },
            {
                label: "Florida",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($599eaf71ec24f702$exports))))
            },
            {
                label: "New England",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($c1bc278aff1d86dd$exports))))
            }
        ],
        [
            //
            {
                label: "West Mediterranean",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($11130b7751811b21$exports))))
            },
            {
                label: "France",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($079d79256b03a7b3$exports))))
            },
            {
                label: "Italy",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($ab64cf15b34dd589$exports))))
            },
            {
                label: "Malta",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($121626504812ba2e$exports))))
            },
            {
                label: "Spain",
                value: $409b4025aeb4477c$var$toLatLongStr((0, (/*@__PURE__*/$parcel$interopDefault($31df448cad09f0cc$exports))))
            }
        ]
    ];
};
const $409b4025aeb4477c$export$d6f36bb87bc56a5c = (renderOptions, isFirstRender)=>{
    const { refine: refine, widgetParams: widgetParams } = renderOptions;
    if (!isFirstRender) // nothing to do.
    return;
    // grab the select element
    const el = document.querySelector(widgetParams.el);
    // create the <option> elements
    $409b4025aeb4477c$var$customGeoPolygonsGrouped().forEach((option)=>{
        // create an optgroup if there are 2 or more.
        if (Array.isArray(option) && option.length > 1) {
            const optgroup = document.createElement("optgroup");
            optgroup.label = option[0].label;
            option.forEach((item)=>{
                const opt = document.createElement("option");
                opt.value = item.value;
                opt.innerHTML = item.label;
                optgroup.appendChild(opt);
            });
            el.appendChild(optgroup);
        } else {
            const opt = document.createElement("option");
            opt.value = option[0].value;
            opt.innerHTML = option[0].label;
            el.appendChild(opt);
        }
    });
    // when the select changes ...
    el.addEventListener("change", (event)=>{
        const value = event.target.value;
        if (value && value !== "") // refine with the select value!
        refine({
            insidePolygon: [
                JSON.parse(value)
            ]
        });
        else // if there is no value or it is empty, clear the refine.
        refine({});
    });
};



var $3bzuQ = parcelRequire("3bzuQ");

var $1WwBr = parcelRequire("1WwBr");

var $1qliK = parcelRequire("1qliK");
//
const $43db247c55069805$var$ALGOLIA_APP_ID = "XS4X4GJGA8";
const $43db247c55069805$var$ALGOLIA_API_KEY = "1b6bee0488dc899e58e57f748383e757";
const $43db247c55069805$var$ALGOLIA_INDEX_NAME = "api_data_idx";
// setup the search client.
const $43db247c55069805$var$searchClient = (0, $1Knfl.liteClient)($43db247c55069805$var$ALGOLIA_APP_ID, $43db247c55069805$var$ALGOLIA_API_KEY);
const $43db247c55069805$var$search = (0, $kB2C5.default)({
    searchClient: $43db247c55069805$var$searchClient,
    appId: $43db247c55069805$var$ALGOLIA_APP_ID,
    indexName: $43db247c55069805$var$ALGOLIA_INDEX_NAME,
    apiKey: $43db247c55069805$var$ALGOLIA_API_KEY,
    insights: false
});
// *
// * Define the search widgets
// *   See: https://www.algolia.com/doc/api-reference/widgets/js/
// *
const $43db247c55069805$var$widgets = [
    // setup base configuration
    (0, $kMjUy.default)({
        hitsPerPage: 51,
        distinct: true
    }),
    //
    // Create the Custom GEO "Destination" select box
    (0, $lNb7j.default)((0, $409b4025aeb4477c$export$d6f36bb87bc56a5c), ()=>{})({
        el: "#refinement-destination",
        searchParameters: {}
    }),
    //
    // Create the "Yacht Type" select box
    (0, $cobnL.default)({
        container: "#refinement-yachtType",
        attribute: "yachtType",
        sortBy: [
            "name:asc"
        ],
        limit: 99,
        templates: {
            defaultOption (data, { html: html }) {
                return html`<span>Any</span>`;
            }
        },
        cssClasses: {
            select: "bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        }
    }),
    //
    // Create the "Yacht Length" select box
    (0, $29Z9A.default)((0, $1WwBr.selectMinMax))({
        el: "#refinement-length",
        attribute: "length_m"
    }),
    //
    // Create the "Number of Guests" select box
    //  Note: * for "TERM" charters, this is the "sleeps" field.
    //        * for "DAY" charters, this is the "cruisingCapacity" field.
    //        * these fields are ~mutually exclusive (that is, they will
    //        * only be set in the index if that charter type is available)
    (0, $29Z9A.default)((0, $1WwBr.selectMinMax))({
        el: "#refinement-sleeps",
        attribute: "sleeps"
    }),
    //
    // refinements - dates
    (0, $29Z9A.default)((0, $3bzuQ.textDateAfter))({
        el: "#refinement-embarkation",
        attribute: "effectiveDateFrom"
    }),
    (0, $29Z9A.default)((0, $3bzuQ.textDateBefore))({
        el: "#refinement-disembarkation",
        attribute: "effectiveDateTo"
    }),
    //
    // create stats area
    (0, $lHFYh.default)({
        container: "#stats"
    }),
    //
    // allow refinements to be cleared
    (0, $aqOVV.default)({
        container: "#clear-refinements",
        templates: {
            resetLabel ({ hasRefinements: hasRefinements }, { html: html }) {
                return html`<span>${hasRefinements ? "[ Reset ]" : ""}</span>`;
            }
        }
    }),
    //
    // the hits!
    //  https://www.algolia.com/doc/api-reference/widgets/hits/js/
    (0, $1qliK.customHits)({
        container: document.querySelector("#hits")
    }),
    //
    // this example will use pagination.
    (0, $cNXNW.default)({
        container: "#pagination",
        cssClasses: {
            root: "w-full",
            list: "flex justify-center",
            item: "mx-2 px-2",
            selectedItem: "bg-gray-200 underline",
            link: "text-blue-800"
        }
    })
];
$43db247c55069805$var$search.addWidgets($43db247c55069805$var$widgets);
$43db247c55069805$var$search.start();


//# sourceMappingURL=search-custom-geo.1b41aac6.js.map
